<template>
  <div class="flex items-center justify-between w-full mr-[100px] user-item">
    <div class="flex items-center flex-1 truncate mr-[30px]">
      <XUserAvatar :data="data" class="avatar"></XUserAvatar>
      <span class="flex-1 truncate text-font-80">
        <span v-if="PERSON.includes(Number(data?.rights_type))">
          {{ data.name || data.account_name || '-' }}
        </span>
        <span v-else>
          {{ data?.org_name || data?.organization_name }}
          <span class="text-font-50"> ({{ data.name || data.account_name || '-' }}) </span>
        </span>
      </span>
      <XUserVerify
        :data="data"
        :status="data?.identify_info?.status"
        disabled
        class="scale-90 ml-[5px]"
      />
    </div>
    <XLevelTag :data="data" :icon="false" class="tags" />
  </div>
</template>

<script lang="ts" setup>
import { type LoginInfo, USER_LEVEL_KEY, type UserInfo } from '~/api/interface/auth';

defineProps<{
  data: LoginInfo | UserInfo;
}>();

const PERSON = [USER_LEVEL_KEY.TASTE, USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE];
</script>

<style lang="scss" scoped>
.user-item {
  .avatar {
    @apply w-[34px] h-[34px];
  }
  .tags {
    @apply h-[28px];
    padding: 5px 10px;
    min-width: 60px;
  }
}
</style>
